module.exports = __webpack_public_path__ + "img/1547474306.ec9e828a.jpg";